export enum ActivityPriorityType {
  HIGH = "HIGH",
  MED = "MED",
  LOW = "LOW"
}
